export function loadBrandingSync() {
  try {
    const xhr = new XMLHttpRequest();
    const base = import.meta.env.DEV ? `${import.meta.env.VITE_SUPABASE_URL}/functions/v1` : '/sfn';
    xhr.open('GET', `${base}/branding-settings`, false); 
    xhr.setRequestHeader('Content-Type', 'application/json');
    
    xhr.send();
    
    if (xhr.status === 200) {
      const branding = JSON.parse(xhr.responseText);
      console.log('🚀 SYNC branding loaded:', branding);
      
      if (branding.companyName) {
        document.title = branding.companyName.trim();
      } else {
        document.title = 'ScheduleHero AI';
      }
      
      if (branding.faviconUrl) {
        const link = document.querySelector("link[rel*='icon']");
        if (link && link instanceof HTMLLinkElement) {
          link.href = branding.faviconUrl;
        }
      }
    } else {
      document.title = 'ScheduleHero AI';
    }
  } catch (error) {
    console.log('⚠️ Sync branding failed, using defaults:', error);
    document.title = 'ScheduleHero AI';
  }
}
